<template>
  <div class="flex flex-col">
    <NavMenuGroupHeader
      :name="text"
      :icon="icon"
      :active="active"
      :collapsed="collapsed"
      @click="emit('toggleMenu', text)"
    />
    <div
      ref="collapsablePanel"
      class="nav-menu-group-container duration grid w-[277px] transition-all"
      :class="{
        active,
        collapsed,
      }"
    >
      <div class="w-full overflow-y-hidden">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, provide, ref, watchEffect } from 'vue';

import NavMenuGroupHeader from '@/modules/layout/components/atoms/NavMenuGroupHeader';
import { MenuGroupItemsCounterFn } from '@/modules/layout/types/keys';

const props = withDefaults(defineProps<{
  text: string,
  icon: string,
  active?: boolean,
  collapsed?: boolean,
  activeRouteName?: string,
}>(), {
  active: false,
  collapsed: false,
  activeRouteName: '',
});

const emit = defineEmits<{
  toggleMenu: [value: string];
}>();

const itemsCount = ref<number>(0);
const increaseGroupItemCounter = () => {
  itemsCount.value++;
};
provide(MenuGroupItemsCounterFn, increaseGroupItemCounter);

const collapsablePanel = ref(null);
const collapsablePanelHeight = computed(() => itemsCount.value * 41);

watchEffect(() => {
  if (!collapsablePanel.value) return;
  if (props.collapsed) {
    (collapsablePanel.value as HTMLElement).style.height = '0';
  } else if (props.active) {
    (collapsablePanel.value as HTMLElement).style.height = `${collapsablePanelHeight.value}px`;
  } else {
    (collapsablePanel.value as HTMLElement).style.height = '0';
  }
});
</script>

<style lang="scss" scoped>
.nav-menu-group-container.collapsed {
  width: 50px;
}
</style>
